"use client";

import { cn } from "@drpcrd/utils";
import { useInView } from "@/lib/use-in-view";
import type { ReactNode } from "react";

type Props = {
  children: ReactNode;
  className?: string;
};

/**
 * Wraps content with a fade-up animation triggered once on scroll entry.
 */
export const FadeInSection = ({ children, className }: Props) => {
  const { ref, inView } = useInView();

  return (
    <div
      ref={ref}
      className={cn(
        "transition-all duration-700",
        inView ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8",
        className,
      )}
    >
      {children}
    </div>
  );
};
